import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useSetupDriverAccount = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onSetupDriverAccountError = (err: AxiosError<ErrorHttpResponse>) => {
        const errorMessage = err?.response?.data?.message;

        // Handle case where message is an object (e.g., validation errors)
        let displayMessage = 'Something went wrong while creating drivers account.';

        if (typeof errorMessage === 'string') {
            displayMessage = errorMessage;
        } else if (typeof errorMessage === 'object' && errorMessage !== null) {
            // Extract first error message from object
            const firstKey = Object.keys(errorMessage)[0];
            displayMessage = errorMessage[firstKey] || displayMessage;
        }

        toast.error(displayMessage);
    };

    const onSetupDriverAccountSuccess = (resetFn: (...args: any) => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Driver account created successfully.');
        resetFn();
    };

    const setupDriverAccount = (data: any, resetFn: (...args: any) => void) => {
        const formData = new FormData();

        formData.append('firstName', data.firstName);
        formData.append('lastName', data.lastName);
        formData.append('email', data.email);
        formData.append('phoneNumber', data.phoneNumber);
        formData.append('startDate', data.startDate);
        formData.append('gender', data.gender);
        formData.append('fleetCategory', data.fleetCategory);
        formData.append('nin', data.nin);
        formData.append('employmentType', data.employmentType);
        formData.append('address', data.address);
        formData.append('dateOfBirth', data.dateOfBirth);

        if (data.profilePicture instanceof File) {
            formData.append('profilePicture', data.profilePicture, data.profilePicture.name);
        } else {
            console.warn('No valid profilePicture provided');
        }

        const url: HttpConfig = {
            url: 'api/v1/dispatchers/manual-entry',
            method: 'post',
            data: formData,
        };

        request(url, onSetupDriverAccountSuccess(resetFn), setLoading, onSetupDriverAccountError);
    };

    return { setupDriverAccount, loading };
};

export default useSetupDriverAccount;
